var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47163 0.719727H7.89301C7.19521 0.719727 6.526 0.996924 6.03258 1.49034C5.53917 1.98375 5.26197 2.65297 5.26197 3.35076V4.92938H3.68335V7.03421H5.26197V11.2439H7.3668V7.03421H8.94542L9.47163 4.92938H7.3668V3.35076C7.3668 3.2112 7.42224 3.07736 7.52092 2.97868C7.6196 2.87999 7.75345 2.82455 7.89301 2.82455H9.47163V0.719727Z",
    stroke: "#D6B893",
    strokeWidth: 1.05241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.629,
    height: 12.629,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8e09e9eb0ab3964cef45b55f91baa9e5.svg";
export { ForwardRef as ReactComponent };